import { Dispatch, SetStateAction, createContext } from 'react';

export const NavContext = createContext<INavContext | object>({});
export interface INavContext {
  setParentNavActive: Dispatch<SetStateAction<boolean>>;
}
